module.exports = __webpack_public_path__ + "static/media/Gala.58c8fbf0.png";